// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// Add the Firebase products that you want to use
import "firebase/firestore";
import "firebase/storage"
import "firebase/auth"

const firebaseConfig = {
   apiKey: "AIzaSyBGuTHEdFtA9OnMXJmKkvUL70X_zH4ivTc",
   authDomain: "tenshinjuku-8ec56.firebaseapp.com",
   databaseURL: "https://tenshinjuku-8ec56.firebaseio.com",
   projectId: "tenshinjuku-8ec56",
   storageBucket: "tenshinjuku-8ec56.appspot.com",
   messagingSenderId: "682159254734",
   appId: "1:682159254734:web:a74aada414044e3a9e749f",
   measurementId: "G-WKFNN7DWKW"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);


const db = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()

export { db, storage, auth }